import { NgModule } from '@angular/core';

import { TermsRoutingModule } from './terms-routing.module';
import { TermsComponent } from './terms.component';
import { CustomLayoutModule } from '../../custom-layout/custom-layout.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/@vex/components/page-layout/page-layout.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MaterialModule } from 'src/app/shared/modules/materia.module';


@NgModule({
  declarations: [TermsComponent],
  imports: [
    TermsRoutingModule,
    CustomLayoutModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MaterialModule
  ],
  providers: [
    CustomizationService
  ],
  exports: [TermsComponent]
})
export class TermsModule { }
